import Api from "..";
import OutputTransmedProcess from "../../dtos/transmed/process/process";
import transform from "../../service/transform";

export default class TransmedProcessApi extends Api {
  constructor() {
    super("transmed");
  }

  public async get(): Promise<OutputTransmedProcess> {
    return await transform(OutputTransmedProcess)((await super.get()).data);
  }
}
